/**
 * Check if `fn` is a function.
 *
 * @param {Function} fn
 * @return {Boolean}
 * @api private
 */
var isObject = require('./is-object');

function isFunction(fn) {
  var tag = isObject(fn) ? Object.prototype.toString.call(fn) : '';
  return tag === '[object Function]';
}

module.exports = isFunction;



/*****************
 ** WEBPACK FOOTER
 ** ./~/superagent/lib/is-function.js
 ** module id = 1453
 ** module chunks = 0
 **/